/**
 * Рантайм-конфиг, отдаваемый файлом `public/config.js` (window.__APP_CONFIG__).
 * Переопределяется через volume без пересборки образа.
 */
type AppRuntimeConfig = {
  /** Адрес бэкенда; приоритетнее запечённого в сборку VITE_API_URL */
  VITE_API_URL?: string;
};

/** Адрес из рантайм-конфига (volume) — имеет приоритет над билд-значением */
const runtimeApiHost = (window as unknown as { __APP_CONFIG__?: AppRuntimeConfig }).__APP_CONFIG__?.VITE_API_URL?.trim();
/** Адрес, запечённый в сборку через import.meta.env.VITE_API_URL */
const buildApiHost = (import.meta.env.VITE_API_URL as string) ?? '';

/**
 * Дефолтный адрес бэкенда.
 * Рантайм-конфиг (volume) имеет приоритет; при его отсутствии — значение из сборки.
 */
export const DEFAULT_API_HOST = runtimeApiHost || buildApiHost;

let apiHostGetter: (() => string) | null = null;

/**
 * Called from app layer to provide actual apiHost from useSettingsStore.
 * If not set, getApiHost() falls back to DEFAULT_API_HOST.
 */
export const setApiHostGetter = (getter: () => string) => {
  apiHostGetter = getter;
};

export const getApiHost = (): string => {
  const value = apiHostGetter ? apiHostGetter() : DEFAULT_API_HOST;
  return value || DEFAULT_API_HOST;
};

let serviceTokenGetter: (() => string | undefined) | null = null;

/**
 * Called from entities layer to provide actual serviceToken from useSettingsStore.
 * If not set, getServiceToken() returns undefined.
 */
export const setServiceTokenGetter = (getter: () => string | undefined) => {
  serviceTokenGetter = getter;
};

export const getServiceToken = (): string | undefined => {
  return serviceTokenGetter ? serviceTokenGetter() : undefined;
};

export const getFullUrl = (url: string) => {
  if (url.startsWith('http')) {
    return url;
  }

  return `${getApiHost()}${url}`;
};
